export const
  COPY_FINISH = 1,
  COPYING = 3,
  COPY_FAILED = 4;
